import { render, staticRenderFns } from "./link-tree-object-dialog.vue?vue&type=template&id=c0924666&"
import script from "./link-tree-object-dialog.vue?vue&type=script&lang=js&"
export * from "./link-tree-object-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports